import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { ToastrService } from 'ngx-toastr';
import { DateRangePickerOptions } from 'app/_helpers/date-range-picker-options';
import { DaterangepickerConfig } from 'ng2-daterangepicker';
import { ReportService } from 'app/_services/report.service';
import { SmmService } from 'app/_services/smm.service';
import { AccountsService } from 'app/_services/accounts.service';
import { ProjectsService } from 'app/_services/projects.service';
import { BsModalService } from 'ngx-bootstrap';

const moment = require('moment');
@Component({
  selector: 'app-projects-list',
  templateUrl: './post-management.component.html',
  styleUrls: ['./post-management.component.scss']
})
export class PostManagementComponent implements OnInit {
  isFilterProject = true;
  notSpam = false;
  showMediaPost = true;
  groupPostType = "";
  sourceByTopic = "";
  public posts = Array();
  public daterange: any = {
    start: moment().startOf('day'),
    end: moment().endOf('day')
  };

  translateSentiment = {
    pos :'Tích cực',
    neg:'Tiêu cực',
    neu: 'Trung tính'
  }

  translate = {
    user_post: 'Bài viết Facebook',
    page_post: 'Bài viết Facebook',
    group_post: 'Bài viết Facebook',
    comment: 'Bình luận Facebook',
    news_article: 'Báo chí',
    news_blog: 'Blog',
    news_forum: 'Diễn đàn',
    youtube: 'Youtube',
    youtube_comment: 'Bình luận Youtube',
    tiktok: 'Bài viết tiktok',
    tiktok_comment: 'Bình luận tiktok',
    instagram:'Bài viết Instagram',
    instagram_comment: 'Bình luận Instagram',
    linkedin : 'Bài viết linkedin',
    linkedin_comment : 'Bình luận linkedin',
    twitter: 'Bài viết twitter',
    twitter_comment : 'Bình luận twitter'
  }

  projectsDisscussion = [];
  projectsDisscussionSelected = [];
  typeTime = "collect_date";
  dataHistory = [];
  showTable = false;
  objectSelected = null;
  actionSelected = [];
  docId = "";
  dataSeeding = [
    {
      id: "isProcessed",
      itemName: "Xử lý bài viết"
    },
    {
      id: "isRead",
      itemName: "Đọc bài viết"
    },
    {
      id: "isIgnored",
      itemName: "Bỏ qua bài viết"
    },
    {
      id: "isPin",
      itemName: "Pin bài viết"
    },
    {
      id: "comment",
      itemName: "Bình luận bài viết"
    }
  ];

  accounts = [];
  accountsSelected = [];

  configDataSeeding = {
    singleSelection: false,
    text: 'Chọn',
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    enableSearchFilter: true,
    badgeShowLimit: 3,
    selectGroup: true
  };

  options: any = {
    locale: { format: 'DD/MM/YYYY HH:mm:ss' },
    timePicker: true,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().endOf('day').toDate(),
    startDate: this.daterange.start,
    endDate: this.daterange.end
  };

  departmentSelected = null;

  threadInfos = Array();
  threadInfoSettings: any;
  informationFlowFilter = [];

  selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start;
    datepicker.end = value.end;
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;
  }
  public content = "";
  public source = "";
  public isBussinessCenter = false;
  public filter = {};

  public projectSelected = [];
  projects = [];
  typeSentiment = "";
  docTypeSelected = [ {'id': 1, 'itemName': 'BÀI VIẾT FACEBOOK', value: 'page_post user_post group_post'}];
  allDocTypes = [
    {'id': 1, 'itemName': 'BÀI VIẾT FACEBOOK', value: 'page_post user_post group_post'},
    {'id': 12, 'itemName': 'FACEBOOK COMMENT', value: 'comment'},
    {'id': 4, 'itemName': 'BÁO CHÍ', value: 'news_article'},
    {'id': 5, 'itemName': 'BLOG', value: 'news_blog'},
    {'id': 6, 'itemName': 'DIỄN ĐÀN', value: 'news_forum'},

    {'id': 7, 'itemName': 'YOUTUBE', value: 'youtube"'},
    {'id': 13, 'itemName': 'YOUTUBE COMMENT', value: 'youtube_comment'},

    {'id': 8, 'itemName': 'TIKTOK', value: 'tiktok'},
    {'id': 15, 'itemName': 'TIKTOK COMMENT', value: 'tiktok_comment'},

    {'id': 9, 'itemName': 'INSTAGRAM', value: '"instagram"'},
    {'id': 14, 'itemName': 'INSTAGRAM COMMENT', value: 'instagram_comment'},
    {'id': 10, 'itemName': 'LINKEDIN', value: '"linkedin"'},
    {'id': 11, 'itemName': 'TWITTER', value: '"twitter"'}
  ]

  projectDropDownSettings = {
    singleSelection: false,
    text: 'Chọn chủ đề',
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    enableSearchFilter: false,
    badgeShowLimit: 2,
    noDataLabel: 'Không có dữ liệu'
  };

  configAngularMultiSelect = {
    singleSelection: false,
    text: 'Vui lòng chọn',
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    enableSearchFilter: true,
    badgeShowLimit: 2,
  };

  dtOptions: DataTables.Settings = {};
  dtOptions_view_history: DataTables.Settings = {};
  public dataTableShow = false;
  modalRef: BsModalRef;
  exclude_keyword = '';
  isLoading: Boolean;

  currentPage = 1;
  pageSize = 10;
  totalPost = 0;
  typeSort = 'numLikes';
  constructor( private modalService: BsModalService,
    private dateRangePickerOptions: DaterangepickerConfig,
    private toastrService: ToastrService,
    private postService: SmmService,
    private projectsService: ProjectsService,
    private reportService: ReportService,
    private accountsService: AccountsService) {
    this.dateRangePickerOptions.settings = DateRangePickerOptions.settingReportFilter;
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: false,
      paging: true,
      searching: false,
      ordering: true,
      language: {
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        infoEmpty: 'Không tìm thấy dữ liệu phù hợp',
        infoFiltered: '(trong _MAX_)',
        lengthMenu: 'Hiển thị _MENU_',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu',
      }
    };

    this.dtOptions_view_history = {
      pagingType: 'full_numbers',
      serverSide: false,
      paging: false,
      info: false,
      searching: false,
      ordering: false,
      language: {
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        infoEmpty: 'Không tìm thấy dữ liệu phù hợp',
        infoFiltered: '(trong _MAX_)',
        lengthMenu: 'Hiển thị _MENU_',
        search: 'Tìm kiếm',
        zeroRecords: ' ',
      }
    };

    this.threadInfoSettings = {
      singleSelection: false,
      text: '--- Chọn ---',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 3,
      disabled: true
    };
    // this.getProject();
    // this.getAccount();
    this.prepareData();
  };

  getDataFromServer() {
    this.dataTableShow = false;
    this.isLoading = true;
    this.posts = [];
    const informationFlow = this.informationFlowFilter.map(source => source.itemValue);
    this.filter = {
      gte: this.daterange.start.valueOf(),
      lte: this.daterange.end.valueOf(),
      typeSentiment: this.typeSentiment,
      projects: this.projectSelected.length > 0 ? this.projectSelected : this.projects,
      content: this.content,
      source: this.source,
      docType: this.docTypeSelected.map(u => u.value).join(' '),
      // isBussinessCenter: this.isBussinessCenter,
      isFilterRaw: (this.isFilterProject) ? false : true,
      index: 'full',
      size: this.pageSize,
      from: (this.currentPage - 1) * this.pageSize,
      sourceByTopic: this.sourceByTopic,
      exclude_keyword: this.exclude_keyword,
      typeSort: this.typeSort,
      projectsDisscussionSelected : this.projectSelected.length ?  this.projectsDisscussionSelected : [],
      typeTime: this.typeTime,
      actionSelected: this.actionSelected,   // hình thức tương tác
      docId: this.docId,
      accountsSelected: this.accountsSelected,
      // notSpam: this.notSpam,
      groupPostType: this.groupPostType,
      informationFlow: informationFlow
    };
    this.postService.searchPost({ filter: this.filter }).subscribe(response => {
      if (response.success) {
        this.posts = this.mappingData(response.data.hits.hits);
        this.totalPost = response.data.hits.total.value;
        this.dataTableShow = true;
        this.isLoading = false;
      } else {
        this.toastrService.error(`${response.msg}`, "Thông báo")
        this.isLoading = false;
      }
    });
  }

  prepareData(): void {
    /* department init */
    this.departmentSelected = { _id: -999, name: '--- Chọn ---' };

    /* accounts init */
    this.getAccountsByDepartment();

    /* project init */
    this.getProject();

    /* information flow */
    this.threadInfos.push(
      { id: 'reactionary', itemName: 'Chính thống', itemValue: 'reactionary' },
      { id: 'notReactionary', itemName: 'Trái chiều', itemValue: 'notReactionary' },
      { id: 'isSpam', itemName: 'Tin nhiễu', itemValue: 'isSpam' }
    );
    this.informationFlowFilter = [];
  }

  getProjectDiscussion() {
    this.projectsDisscussion = [];
    this.projectsDisscussionSelected = [];
    if(this.projectSelected.length > 0){
      this.projectsService.getProjectDiscussionByProject({projects : this.projectSelected}).subscribe(res => {
        if (res.success) {
          res.data.projectsDiscussion
          .forEach(element => {
            let obj = {
              id: element._id,
              itemName: element.name,
              value: element.name
            };
            this.projectsDisscussion.push(obj);
          });
        }
      })
    }
  }

  mappingData(hits) {
    let results = [];
    hits.forEach(item => {
      let reportItem = {
        content: item._source.message || item._source.content || item._source.description || 'Nội dung trống',
        // chu_de : item["_source"].topicSentiment.map(a => a.topic).join(" , "),
        // chu_de_thao_luan : item["_source"].topicSentimentDiscuss.map(a => a.discuss).join(" , "),

        chu_de : item["_source"].topicSentiment?item["_source"].topicSentiment.map(a => a.topic).join(" , ") : "",
        chu_de_thao_luan : item["_source"].topicSentimentDiscuss?item["_source"].topicSentimentDiscuss.map(a => a.discuss).join(" , ") :"",

        docType: this.translate[item._source.docType] ? this.translate[item._source.docType] : '-',
        linkSource : this.getSourceLink(item),
        linkSocial : this.getSocialLink(item),
        createDate :  moment(item._source.createDate).format('DD/MM/YYYY h:mm:ss a'),
        collectDate:  moment(item._source.collectDate).format('DD/MM/YYYY h:mm:ss a'),
        sentiment: this.getSentiment(item),

        numLikes: item["_source"].numLikes + (item["_source"].numReactions || 0),
        numShares: item["_source"].numShares,
        numComments: item["_source"].numComments,

        total_interactive : (item["_source"].numShares || 0 ) + (item["_source"].numComments || 0 ) + (item["_source"].numLikes || 0 ) + (item["_source"].numReactions || 0 ),
        numView : item["_source"].numView != undefined ? item['_source'].numView : 0 ,
        province : item["_source"].province || "Không xác định",

        employee : (item["_source"].processAccount && item["_source"].processAccount.length) ? item["_source"].processAccount[0].username: '',
        type_process: this.getTypeProcess(item),
        time_process:  (item["_source"].processAccount && item["_source"].processAccount.length) ? moment(item["_source"].processAccount[0].createDate).format('DD/MM/YYYY h:mm:ss a'): '',
      }
      reportItem['post_level'] = this.getPostLever(reportItem['total_interactive']);
      reportItem['bot_comment'] = 0;
      reportItem['ktv_comment'] = item["_source"]['commentSls'] ? item["_source"]['commentSls'].length : 0;
      reportItem['postId'] = item["_source"]['docId'];
      reportItem['type'] = item["_source"]['docType'];
      reportItem['link'] = item["_source"]['link'];

      //commentSls
      results.push(reportItem);
    });
    return results;
  }

  getPostLever(total_interactive) {
    if(total_interactive < 200) {
      return 'Cấp độ 1';
    }
    return 'Cấp độ 2';
  }

  getTypeProcess(item) {
    let result = [];
    if(item['_source'].isProcessed) {
      result.push('Xử lý bài viết');
    }
    if(item['_source'].isRead) {
      result.push('Đọc bài viết');
    }
    if(item['_source'].isIgnored) {
      result.push('Bỏ qua bài viết');
    }
    if(item['_source'].isPin) {
      result.push('Pin bài viết');
    }
    if((item['_source'].commentSls && item['_source'].commentSls.length > 0) || (item['_source'].botCommentSls && item['_source'].botCommentSls.length > 0)) {
      result.push('Bình luận bài viết');
    }
    return result.join(", ");
  }

  getSentiment(item) {
    let sentiment = '-';
    if(item['_source'].topicSentiment && item['_source'].topicSentiment.length) {
      sentiment =  item['_source'].topicSentiment[0].sentiment;
      sentiment = this.translateSentiment[sentiment] ;
    }
    return sentiment;
  }

  getSourceLink(item) {
    let linkSource = item._source.link;;

    if(item._source.docType == 'page_post' || item._source.docType == 'user_post' || item._source.docType == 'group_post' || item._source.docType == 'comment') {
      return `https://facebook.com/${item._id}`;
    }
    if (item['_source'].docType == 'tiktok_comment') {
      linkSource = `https://www.tiktok.com/@${item['_source'].name}/video/${item['_source'].postId}`;
    }
    if (item['_source'].docType == 'youtube_comment') {
      linkSource = `https://www.youtube.com/watch?v=${item['_source'].postId}`;
    }

    return linkSource;
  }

  getSocialLink(item) {
    let linkSocial = "";
    // const base_url = (ServiceConfig.host == "https://vnsocial.vnptmedia.vn/api") ? "http://vnsocial.vnptmedia.vn" : "https://vnhearing.vnptmedia.vn";
    let projectId = (item['_source'].topicSentiment && item['_source'].topicSentiment.length) ? item['_source'].topicSentiment[0].id : null;

    if (!projectId) {
      return '#';
    }
    if (this.isFilterProject && this.projectSelected.length) {
      projectId = this.projectSelected[0].id;
    }

    let baseUrl = window.location.hostname;
    baseUrl = baseUrl == 'localhost' ? baseUrl + ':4200' : baseUrl;
    baseUrl = window.location.protocol + '//' + baseUrl;
    linkSocial = `${baseUrl}/project/${projectId}/posts?docId=${item['_id']}&postIndex=${item['_index']}`;

    if (item['_source'].docType.includes('comment')) {
      linkSocial = `${baseUrl}/project/${projectId}/posts?docId=${item['_source'].postId}`
        +`&postIndex=${item['_source'].postIndex}&commentId=${item['_source'].docId}`;
    }

    return linkSocial;
  }

  pageChange(number) {
    this.posts = [];
    this.currentPage = number;
    this.getDataFromServer();
  }

  getProject() {
    const body = {
      departmentId : this.departmentSelected._id !== -999 ? this.departmentSelected._id : null
    }
    this.projects = [];
    this.projectSelected = [];
    this.projectsService.getProjectByDepartment(body).subscribe(response => {
      if (response.success) {
        response.data.projects.forEach(element => {
          const obj = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.projects.push(obj);
        });
      }
    });
  }

  getAccount() {
    this.accountsService.getAccountListOnline().subscribe(response => {
      if (response.success) {
        response.data.accounts.forEach(element => {
          const accountItem = {
            id: element._id,
            itemName: element.username,
            value: element.username
          }
          this.accounts.push(accountItem);
        });
      }
    });
  }

  exportData() {
    if (this.posts.length == 0) {
      this.toastrService.error("Không có dữ liệu để xuất báo cáo!", "Thông báo!");
    } else {
      const informationFlow = this.informationFlowFilter.map(source => source.itemValue);
      const filter = {
        gte: this.daterange.start.valueOf(),
        lte: this.daterange.end.valueOf(),
        typeSentiment: this.typeSentiment,
        projects: this.projectSelected.length > 0 ? this.projectSelected : this.projects,
        projectsDisscussionSelected : this.projectSelected.length ?  this.projectsDisscussionSelected : [],
        content: this.content,
        source: this.source,
        docType: this.docTypeSelected.map(u => u.value).join(' '),
        // isBussinessCenter: this.isBussinessCenter,
        isFilterRaw: (this.isFilterProject) ? false : true,
        index: 'full',
        size: 10000,
        from: 0,
        exclude_keyword: this.exclude_keyword,
        typeSort: this.typeSort,
        typeTime: this.typeTime,
        actionSelected: this.actionSelected,   // hình thức tương tác
        docId: this.docId,
        accountsSelected: this.accountsSelected,
        groupPostType: this.groupPostType,
        // notSpam: this.notSpam
        informationFlow: informationFlow
      };
      this.toastrService.success('Hệ thống đang xử lý vui lòng đợi trong ít phút', 'Thông báo');
      this.isLoading = true;
      this.postService.searchPost({ filter: filter }).subscribe(response => {
        if (response.success) {
            let data = this.mappingData(response.data.hits.hits);
            let dataReport = [];
            const header1 = [
              { start: 1 },
              { name: "Nội dung tương tác",rowspan: 2 },
              { name: "Chủ đề",rowspan: 2 },
              { name: "Chủ đề thảo luận",rowspan: 2 },
              { name: "Loại nội dung",rowspan: 2 },
              { name: "Link gốc",rowspan: 2 },
              { name: "Link Social",rowspan: 2 },
              { name: "Ngày tạo",rowspan: 2 },
              { name: "Ngày về hệ thống",rowspan: 2 },
              { name: "Cảm xúc",rowspan: 2 },
              { name: "Lượt cảm xúc",rowspan: 2 },
              { name: "Lượt chia sẻ",rowspan: 2 },
              { name: "Lượt bình luận",rowspan: 2 },
              { name: "Tổng tương tác",rowspan: 2 },
              { name: "Lượt xem",rowspan: 2 },
              { name: "Tỉnh thành",rowspan: 2 },
              { name: "Tình hình xử lý",colspan: 3 },
              { name: "Cấp độ bài viết",rowspan: 2 },
              { name: "Số lượng com seeding",colspan: 2 }
            ];
            const header2 = [
              { start: 16 },
              {
                name: "Nhân viên"
              },
              {
                name: "Hình thức tương tác"
              },
              {
                name: "Thời gian tương tác"
              },
              {

              },
              {
                name: "BOT"
              },
              {
                name: "KTV"
              }
            ]
            const dataReport1 = { name: "Báo cáo danh sách bài viết", header: [header1,header2], data: data, notStt: false };
            dataReport.push(dataReport1);
            this.isLoading = false;
            this.reportService.exportReportToExcel(dataReport, 'Báo cáo danh sách bài viết');
          }
      });
    }
  }
  closeModal() {
    this.modalRef.hide();
  }
  public viewHistory(post, template_history) {
    this.showTable = false;
    this.objectSelected = post;
    this.dataHistory = [];
    // lấy lịch sử seeding
    let body = {postId: post.postId}
    this.postService.getHistorySeeding(body).subscribe(response => {
      if (response.success) {
        for(let item of response.data){
          if(item.accountSeeding != null){
            this.dataHistory.push(item);
          }
        }
        this.showTable = true;
      } else {
        this.toastrService.error(`${response.msg}`, "Thông báo")
      }
    });

    this.modalRef = this.modalService.show(template_history, {
      keyboard: false,
      backdrop: 'static',
      class: 'modal-lg'
    });
  }

  changeSize() {
    this.posts = [] ;
    this.currentPage = 1 ;
    this.getDataFromServer();
  }

  changeDocType(){
    this.showMediaPost = false;
    if(this.docTypeSelected.length == 0){
      this.showMediaPost = false;
    }else{
      for(let item of this.docTypeSelected){
        if(item.itemName == "BÀI VIẾT FACEBOOK" || item.itemName == "FACEBOOK COMMENT"){
          this.showMediaPost = true;
        }
      }
    }
  }
  onChangeDepartment(value) {
    this.departmentSelected = value;

    this.getProject();
    this.getAccountsByDepartment();
  }
  getAccountsByDepartment() {
    const body = {
      departmentId : this.departmentSelected._id !== -999 ? this.departmentSelected._id : null
    }
    this.accountsService.findAccountsByDepartment(body).subscribe(response => {
      this.accountsSelected = [];
      this.accounts = [];
      if (response.success) {
        response.data.accounts.forEach(element => {
          const accountItem = {
            id: element._id,
            itemName: element.username,
            value: element.username
          }
          this.accounts.push(accountItem);
        });
      }
    });
  }

  /* project filter change */
  onItemSelect(item: any) {
    this.threadInfoSettings = { ...this.threadInfoSettings, disabled: this.projectSelected.length !== 1 };
    this.informationFlowFilter = this.projectSelected.length !== 1 ? [] : this.informationFlowFilter
  }
  onItemDeSelect(item: any) {
    this.threadInfoSettings = { ...this.threadInfoSettings, disabled: this.projectSelected.length !== 1 };
    this.informationFlowFilter = this.projectSelected.length !== 1 ? [] : this.informationFlowFilter
  }

  onSelectAll(items: any) {
    this.threadInfoSettings = { ...this.threadInfoSettings, disabled: this.projectSelected.length !== 1 };
    this.informationFlowFilter = this.projectSelected.length !== 1 ? [] : this.informationFlowFilter
  }

  onDeSelectAll(items: any) {
    this.threadInfoSettings = { ...this.threadInfoSettings, disabled: this.projectSelected.length !== 1 };
    this.informationFlowFilter = this.projectSelected.length !== 1 ? [] : this.informationFlowFilter
  }
  /* end project filter change */
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/post-management/post-management.component.ts